<script setup>
import { onMounted, ref } from 'vue'
import DataLayer from '@services/data-layer/index'
import ArtistBlock from '@components/artist/artist-block'

const artists = ref([])

onMounted(() => {
    DataLayer.artists.getTrending(7).then(response => {
        artists.value = response.body
    })
})
</script>

<template>
    <div v-if="artists && artists.length" >
        <BaseSection title="Trending Artists" >
            <ArtistBlock :artists="artists" />
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
